__turbopack_context__.v({
  "buttonContainer": "how-it-works-module__abVpXq__buttonContainer",
  "centered": "how-it-works-module__abVpXq__centered",
  "examplePrizeImage": "how-it-works-module__abVpXq__examplePrizeImage",
  "examplePrizeImageBigger": "how-it-works-module__abVpXq__examplePrizeImageBigger",
  "extraRow": "how-it-works-module__abVpXq__extraRow",
  "goodToKnowCard": "how-it-works-module__abVpXq__goodToKnowCard",
  "goodToKnowCarousel": "how-it-works-module__abVpXq__goodToKnowCarousel",
  "goodToKnowFaqs": "how-it-works-module__abVpXq__goodToKnowFaqs",
  "infoButton": "how-it-works-module__abVpXq__infoButton",
  "matchBanner": "how-it-works-module__abVpXq__matchBanner",
  "modalHeading": "how-it-works-module__abVpXq__modalHeading",
  "postalInfo": "how-it-works-module__abVpXq__postalInfo",
  "prizeList": "how-it-works-module__abVpXq__prizeList",
  "prizeListArrow": "how-it-works-module__abVpXq__prizeListArrow",
  "prizeListBadge": "how-it-works-module__abVpXq__prizeListBadge",
  "prizeListInfo": "how-it-works-module__abVpXq__prizeListInfo",
  "prizeListMatches": "how-it-works-module__abVpXq__prizeListMatches",
  "prizeListMatchesBalls": "how-it-works-module__abVpXq__prizeListMatchesBalls",
  "prizeListTier": "how-it-works-module__abVpXq__prizeListTier",
  "prizeListWorth": "how-it-works-module__abVpXq__prizeListWorth",
  "prizeRowInner": "how-it-works-module__abVpXq__prizeRowInner",
  "prizeTierTitle": "how-it-works-module__abVpXq__prizeTierTitle",
  "showMore": "how-it-works-module__abVpXq__showMore",
  "topRow": "how-it-works-module__abVpXq__topRow",
  "withExtraRows": "how-it-works-module__abVpXq__withExtraRows",
});
